import { render, staticRenderFns } from "./CategoriesTab.vue?vue&type=template&id=6a2a626e&scoped=true&"
import script from "./CategoriesTab.vue?vue&type=script&lang=js&"
export * from "./CategoriesTab.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesTab.vue?vue&type=style&index=0&id=6a2a626e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2a626e",
  null
  
)

export default component.exports